// General config constants used in the app

/** Partner return link after wizard (override in env for non-prod if needed) */
export const BEELY_PARTNER_SITE_URL = "https://beely.fi";

export const VEHICLE_MAX_MILEAGE_LIMIT = 250000; // km
export const MOTO_MAX_MILEAGE_LIMIT = 100000; // km
export const VEHICLE_MAX_AGE_LIMIT = 2010; // only this and newer vehicles are accepted
export const MAX_IMAGE_SIZE = 15728640; // in bytes, 15MB
export const MAX_FEEDBACK_IMAGES_COUNT = 5;
// Pre-compression: reject files larger than this before even trying to compress
export const MAX_FEEDBACK_INPUT_IMAGE_SIZE_MB = 15;
export const MAX_FEEDBACK_INPUT_IMAGE_SIZE =
  MAX_FEEDBACK_INPUT_IMAGE_SIZE_MB * 1024 * 1024;
// Post-compression upload limit — matches Lambda payload headroom
export const MAX_FEEDBACK_IMAGE_SIZE_MB = 4;
export const MAX_FEEDBACK_IMAGE_SIZE = MAX_FEEDBACK_IMAGE_SIZE_MB * 1024 * 1024;
export const MAX_FEEDBACK_MESSAGE_LENGTH = 5000;
export const MAX_IMAGES_COUNT = 62; // maximum number of images allowed (global limit)

// Section-specific maximum image counts
export const MAX_GENERAL_IMAGES_COUNT = 30; // maximum number of general images per section
export const MAX_CARAVAN_GENERAL_IMAGES_COUNT = 30; // maximum number of general images for caravans
export const MAX_DAMAGE_IMAGES_COUNT = 16; // maximum number of damage images per section
export const MAX_OTHER_IMAGES_COUNT = 16; // maximum number of other/additional images per section
export const MAX_ADDITIONAL_INFO_IMAGES_COUNT = 10; // maximum number of images for auction additional info
export const MIN_SUGGESTED_QUALITY_IMAGE_SIZE = 102400; // in bytes, 100kB
export const MAX_NEGOTIATION_MESSAGES = 10; // messages
export const MAX_NEGOTIATION_MESSAGE_LENGTH = 1000; // characters
export const MAX_WITHDRAWAL_MESSAGE_LENGTH = 1000; // characters
export const MAX_QUESTION_LENGTH = 1000; // characters
export const MAX_QUESTION_ANSWER_LENGTH = 1000; // characters
export const MAX_TRIM_LEVEL_LENGTH = 100; // characters
export const MAX_WINDSHIELD_DESCRIPTION_LENGTH = 200; // characters
export const MAX_INCOMPLETE_MAINTENANCE_BOOK_DESCRIPTION_LENGTH = 1000; // characters
export const MAX_DAMAGES_DESCRIPTION_LENGTH = 1000; // characters
export const MAX_ACCESSORIES_DESCRIPTION_LENGTH = 1000; // characters
export const MAX_FREE_DESCRIPTION_LENGTH = 1000; // characters
export const MINIMUM_BID_RAISE = 50; // EUR
export const MAX_NOTE_LENGTH = 1000; // characters
export const MAX_FLAG_REASON_LENGTH = 500; // characters
export const MAX_FLAGS_PER_DEALER_PER_AUCTION = 3; // enforced server-side
export const MAX_BID_MULTIPLIER = 5;
export const MAX_ALLOWED_BID = 999999;
export const NOTIFICATION_SHOW_TIME_IN_MS = 5000; // ms, 5 secs
export const BADGES_SHOW_TIME_IN_MS = 5000; // ms, 5 secs
export const STEP_PRICE_ESTIMATE_MULTIPLIER = 2; // multiplier for price estimate validator
export const PRICE_ESTIMATE_RANGE_LOW_MULTIPLIER = 0.9; // multiplier for price estimate range low
export const PRICE_ESTIMATE_RANGE_HIGH_MULTIPLIER = 1.1; // multiplier for price estimate range high
export const PRICE_INDICATOR_RANGE_PADDING_PERCENT = 0.2; // fraction the indicator track extends beyond the estimate range
export const SUPPORTED_MIME_TYPES_FOR_MEDIA_UPLOADS =
  "image/jpeg,image/png,image/webp,image/heic,image/heif";
export const SUPPORTED_FILE_EXTENSIONS_FOR_MEDIA_UPLOADS = [
  "jpg",
  "jpeg",
  "png",
  "webp",
  "heic",
  "heif"
];

// Dropzone accept configuration - centralized for consistency
export const DROPZONE_ACCEPT_CONFIG = {
  "image/jpeg": [".jpg", ".jpeg"],
  "image/png": [".png"],
  "image/webp": [".webp"],
  "image/heic": [".heic"],
  "image/heif": [".heif"]
};

// File input accept string with explicit extensions for better browser compatibility
// Chrome sometimes doesn't recognize HEIC MIME types, so we add explicit extensions
export const FILE_INPUT_ACCEPT_STRING = `${SUPPORTED_MIME_TYPES_FOR_MEDIA_UPLOADS},${SUPPORTED_FILE_EXTENSIONS_FOR_MEDIA_UPLOADS.map(
  (ext) => `.${ext}`
).join(",")}`;
export const AUCTION_WIZARD_VERSION: "v1" | "v2" = "v2";
export const OFFER_ACCEPTED_INSTRUCTIONS_SHOW_TIME_IN_S = 1209600; // two weeks in seconds
